/* Mell — страница „Промоции": отваряне на подробния изглед на промоция. */
(function(){
  function open(el){
    if (!el) return;
    el.hidden = false;
    document.body.classList.add('mp-locked');
    var x = el.querySelector('.mp-modal__x'); if (x) x.focus();
  }
  function close(el){
    el.hidden = true;
    if (!document.querySelector('.mp-modal:not([hidden])')) document.body.classList.remove('mp-locked');
  }
  document.addEventListener('click', function(e){
    var card = e.target.closest('.mp-card');
    if (card){ open(document.getElementById('promo-' + card.dataset.promo)); return; }
    var link = e.target.closest('a[href^="#promo-"]');
    if (link){ e.preventDefault(); open(document.getElementById(link.getAttribute('href').slice(1))); return; }
    if (e.target.closest('[data-mp-close]')){
      var m = e.target.closest('.mp-modal'); if (m) close(m);
    }
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    var m = document.querySelector('.mp-modal:not([hidden])'); if (m) close(m);
  });
  // директен линк към промоция: /pages/promoczii#promo-<handle>
  window.addEventListener('DOMContentLoaded', function(){
    if (location.hash.indexOf('#promo-') === 0) open(document.getElementById(location.hash.slice(1)));
  });
})();
